'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SiteFooter;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FooterColumn = require('./FooterColumn');

var _FooterColumn2 = _interopRequireDefault(_FooterColumn);

var _InspiringMessages = require('./InspiringMessages/InspiringMessages');

var _InspiringMessages2 = _interopRequireDefault(_InspiringMessages);

var _Infographics = require('./Infographics/Infographics');

var _Infographics2 = _interopRequireDefault(_Infographics);

var _Copyright = require('./Copyright');

var _Copyright2 = _interopRequireDefault(_Copyright);

var _CareerCategories = require('./CareerCategories/CareerCategories');

var _CareerCategories2 = _interopRequireDefault(_CareerCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'site-footer';

function SiteFooter(_ref) {
  var _ref$footer = _ref.footer,
      _ref$footer$links = _ref$footer.links,
      training = _ref$footer$links.training,
      employers = _ref$footer$links.employers,
      about = _ref$footer$links.about,
      inspiringMessages = _ref$footer.inspiringMessages,
      infographics = _ref$footer.infographics,
      copyright = _ref$footer.copyright,
      careerCategories = _ref$footer.careerCategories;

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    _react2.default.createElement(_InspiringMessages2.default, { messages: inspiringMessages }),
    _react2.default.createElement(_Infographics2.default, { infographics: infographics }),
    _react2.default.createElement(
      'div',
      { className: 'wrapper' },
      _react2.default.createElement(
        'div',
        { className: 'footer-links' },
        _react2.default.createElement(
          'div',
          { className: 'wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'columns' },
            _react2.default.createElement(
              'div',
              { className: 'column' },
              _react2.default.createElement(_FooterColumn2.default, {
                title: training.title,
                href: training.href,
                links: training.links || []
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'column' },
              _react2.default.createElement(_FooterColumn2.default, {
                title: about.title,
                href: about.href,
                links: about.links || []
              }),
              _react2.default.createElement(_FooterColumn2.default, {
                title: employers.title,
                href: employers.href,
                links: employers.links || []
              })
            )
          ),
          _react2.default.createElement(_CareerCategories2.default, { careerCategories: careerCategories })
        )
      ),
      _react2.default.createElement(_Copyright2.default, { copyright: copyright })
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/SiteFooter/SiteFooter.jsx
// module id = 1128
// module chunks = 0